module.exports = __webpack_public_path__ + "img/group-392.956c19f.png";